import { isLowerEnvironment } from "./utils";

let DOMAIN = 'https://api.stitchfin.com';

// @ts-ignore
const LOCAL= "https://api.stitchfin.com";
// @ts-ignore
const DEFAULT_URL = "https://api.ovum.stitchfinapp.com";
const PROD_URL = 'https://api.stitchfinapp.com';

const clientDomainMapping: Record<string, Record<string, string>> ={
  'stluke':{
    'dev': "https://stluke.stage.api.stitchfinapp.com",
    'prod': "https://stluke.api.stitchfinapp.com",
  },
  'ovum': {
    'dev': 'https://api.ovum.stage.stitchfinapp.com',
    'prod': DEFAULT_URL,
  },
  'abchospitalportal': {
    'dev': LOCAL,
    'prod': PROD_URL,
  },
  'lavenderportal': {
    'dev': DOMAIN,
    'prod': PROD_URL,
  },
  'axis': {
    // 'dev': LOCAL,
    'dev': "https://axis.stage1.api.stitchfinapp.com",
    'prod': "https://axis.api.stitchfinapp.com",
  },
  'default': {
    'dev': DOMAIN,
    'prod': PROD_URL,
  }
}

export const getDomain = () => {
    const env = isLowerEnvironment() ? 'dev' : 'prod';
    const objs = Object.keys(clientDomainMapping);
    const client = objs.find((obj) => window.location.hostname.includes(obj)) || "default";
    const clientConfig = clientDomainMapping[client];
    const domain = clientConfig?.[env] || DOMAIN;
    return domain;
}

export const getSandraDomain = () => {
    if(isLowerEnvironment()) {
        return 'https://sandra1.api.stage.stitchfinapp.com/chat/';
    }
    return 'https://sandraprod.api.stitchfinapp.com/chat/';
}
export const SESSION_TIMEOUT_DAY = 24 * 60 * 60 * 1000;

/** UUID format guard for workflow/session IDs in routes and API calls. */
export const UUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
